export type SearchAddressForm = { apn: string, zipCode: string, streetAddress: string, zipCode1?: string, zipCode2?: string }
export const createInitialValuesFromQuery = ({ apn, streetAddress, zipCode }: Partial<SearchAddressForm>) => {
    const initialValues: Partial<SearchAddressForm> = { apn, streetAddress }
    if (zipCode) {
        if (apn) { initialValues.zipCode1 = zipCode } else { initialValues.zipCode2 = zipCode }
    }

    return { initialValues }
}
